export const MATERIAL_FORMULA_VARS = {
  sqf: "SqFt",
  tlfh: "Hip",
  tlfr: "Ridge",
  lfe: "Eaves",
  lfr: "Rakes",
  tlfv: "Valleys",
  wf: "Waste%",
  flsh: "Flashings",
  sflsh: "Step Flashings",
} as const;

export type MaterialFormulaVar = keyof typeof MATERIAL_FORMULA_VARS;

export const MATERIAL_FORMULA_VARS_LIST = Object.values(MATERIAL_FORMULA_VARS);
